/**
 * ⚠️ CRA inlines every REACT_APP_* value at BUILD time, not at runtime. Adding
 * or changing one in the Amplify console therefore does nothing to a bundle that
 * is already built — the environment needs a new BUILD, not a restart or a
 * cache invalidation. If a freshly configured flag appears to be ignored, check
 * that a build has run since it was set before looking for a bug in the code
 * that reads it.
 */
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { GlobalContextProvider } from "context/globalContext";
import {Toaster} from "react-hot-toast";
import ErrorBoundary from "components/errorBoundary/ErrorBoundary";
import { applyTokenCssVars } from "theme/cssVars";
import { applyBrandFavicon } from "theme/brands";

// Before the first render: the stylesheets read the design tokens as `var(--tk-*)`.
applyTokenCssVars();
// The tab icon of the active brand (theme/brands); index.html ships Zenvoya's.
applyBrandFavicon();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // Outermost on purpose: the providers below can throw too, and an error in one
  // of them would otherwise unmount the tree and leave a blank document.
  <ErrorBoundary>
  <BrowserRouter>
  <GlobalContextProvider>
  <Toaster
        position="bottom-center"
        reverseOrder={false}
      />
    <App />
    </GlobalContextProvider>
  </BrowserRouter>
  </ErrorBoundary>
);
